<template>
  <page-wrapper ref="pageEl" title="Juristic Feature">
    <div class="header">
      <div class="list-head">
        <div class="col-12 row">
          <ul class="nav tabs">
            <li
              :class="{ active: currentTab === 'L,H' }"
              class="tab mx-3"
              @click="setTab('L,H')"
            >
              <h3>SC Project</h3>
            </li>
            <li
              :class="{ active: currentTab === 'NSL,NSH' }"
              class="tab mx-3"
              @click="setTab('NSL,NSH')"
            >
              <h3>None SC Project</h3>
            </li>
            <li
              :class="{ active: currentTab === 'B' }"
              class="tab mx-3"
              @click="setTab('B')"
            >
              <h3>Building Management</h3>
            </li>
          </ul>
        </div>
      </div>
      <div class="search-head">
        <div class="col-12 row">
          <div class="col-12 col-md-6 mb-3">
            <label>ชื่อโครงการ</label>
            <el-input
              v-model="query.name"
              placeholder="ระบุชื่อโครงการ"
            ></el-input>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <label>รหัสโครงการ</label>
            <el-input
              v-model="query.code"
              placeholder="ระบุรหัสโครงการ"
            ></el-input>
          </div>
        </div>
        <div class="text-end">
          <sc-button variant="secondary" @click="handleClickSearchButton()"
            >ค้นหา</sc-button
          >
        </div>
      </div>
    </div>
    <div class="list mt-5">
      <p v-if="items.length" class="mb-2 mt-2 text-end">{{ totalCount }}</p>
      <div class="col-12">
        <juristic-feature-project-row
          v-for="(item, index) in items"
          :key="index"
          v-bind="item"
        ></juristic-feature-project-row>
      </div>
    </div>
    <div>
      <div class="text-center mt-3">
        <el-pagination
          :total="total"
          :size="10"
          :current-page="queryParams.page"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper"
import ScButton from "@/lib/components/ScButton"
import { backendAdminClient } from "@/dependencies"
import JuristicFeatureProjectRow from "../components/JuristicFeatureProjectRow"

export default {
  components: {
    PageWrapper,
    ScButton,
    JuristicFeatureProjectRow,
  },
  data() {
    const query = { type: "L,H", name: null, code: null, page: 1 }

    const projectType = {
      L: "แนวราบ",
      H: "แนวสูง",
      NSL: "แนวราบ",
      NSH: "แนวสูง",
      B: "อาคาร",
    }

    return {
      currentTab: "L,H",
      query,
      items: [],
      size: 10,
      total: 0,
      projectType,
    }
  },
  computed: {
    totalCount() {
      const limit = 10
      const total = this.total.toLocaleString()
      const currentTotalItem = this.items.length
      const isLastPage = limit > currentTotalItem
      const currentPage = this.queryParams.page
      const end = (isLastPage ? total : currentPage * limit).toLocaleString()
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString()

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`
    },
    queryParams() {
      return {
        type: this.$route.query.type || "L,H",
        name: this.$route.query.name || null,
        code: this.$route.query.code || null,
        page: parseInt(this.$route.query.page, 10) || 1,
      }
    },
  },
  watch: {
    "$route.query": async function routeQueryWatcher() {
      this.setupQuery()
      await this.setupData()

      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
  },
  created() {
    this.setupData()
  },
  methods: {
    setTab(tab) {
      if (this.currentTab === tab) return

      this.currentTab = tab

      this.query = { ...this.query, type: tab, page: 1 }
      this.handleClickSearchButton()
    },
    async setupQuery() {
      this.query = {
        type: this.$route.query.type || "L,H",
        name: this.$route.query.name || null,
        code: this.$route.query.code || null,
        page: this.$route.query.page || 1,
      }
    },
    handleClickSearchButton() {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, ...this.query, page: 1 },
      }

      this.$router.replace(route)
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page },
      }

      this.$router.replace(route)
    },
    async setupData() {
      const params = this.queryParams

      try {
        const { items, pagination } = await this.fetchData(params);

        this.total = pagination.total_records;

        this.items = items.map(project => ({
            id: project.id,
            code: project.code,
            title: project.name,
            icon: project.icon,
            type: this.projectType[project.type],
            serviceCount: project.service_feature_count,
            route: {
              name: "JuristicFeatureProjectEditor",
              params: { id: project.id }
            }
          }));
      } catch (error) {
        this.$message.error("ไม่สามารถโหลดข้อมูลโครงการได้ กรุณาลองใหม่อีกครั้ง");
      }
    },
    async fetchData() {
      const response =
        await backendAdminClient.projectJuristic.getProjectJuristicFeature(
          this.query,
        )

      return response.data.result
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: $space 0;
  border-bottom: $border;
}

.search-head {
  padding: 24px 16px 0 16px;

  label {
    font-weight: bold;
  }
}

.list-head {
  padding: 0px 16px 0 16px;

  .tabs {
    height: 60px;
    align-items: center;

    .tab {
      border: none;
      color: #8c8786;
      font-weight: 500;
      text-align: center;

      &.active {
        border-bottom: 2px solid $orange;

        h3 {
          font-weight: bold;
          color: $black;
        }
      }
      h3 {
        font-size: 20px;
        line-height: 1.38;
        color: inherit;
        margin: 0;
      }
    }
  }
  .input-group {
    &-text {
      background: $white;
      border-right: none;
      border-radius: 25px 0 0 25px;
      line-height: 40px;
    }
    .form-control {
      font-size: 14px;
      font-weight: 500;
      color: #616161;
      line-height: 1.87;
      border: 1px solid #ced4da;
      border-left: none;
      border-radius: 0 25px 25px 0;
    }
  }
}

.list {
  padding: 0px 16px 0 16px;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .list-head {
    .tabs {
      .tab {
        min-width: 70px;
      }
    }
  }
}
</style>
